<template>
	<div class="view-payment-breakdown">
		<Modal
			:show="showPaymentBreakdown"
			content_class="col-12 col-lg-9 col-xl-8 confirm-modal"
		>
			<template slot="content" v-if="invoice_details">
				<div>
					<div class="clearfix top">
						<div class="left-content f-l">
							<div class="content-title">
								Payment Breakdown for Invoice:
								{{ invoice_details.ref }}
							</div>
						</div>
						<div
							class="close-modal f-r"
							@click="
								$store.commit('showPaymentBreakdown', false)
							"
						>
							<i class="fa fa-times"></i>
						</div>
					</div>

					<div
						class="no-padding"
						v-if="payment_breakdown && payment_breakdown.length > 0"
					>
						<div class="row">
							<div class="col-12 col-lg-11 col-xl-10">
								<div
									class="card fee-card"
									v-for="(payment, i) in payment_breakdown"
									:key="i"
								>
									<div class="clearfix">
										<div
											class="f-r status tx-green"
											:class="{
												'tx-yellow':
													payment.status !== 'paid',
											}"
										>
											{{ payment.status }}
										</div>
									</div>

									<div class="ref">
										{{ payment.term_details.term_name }} ({{
											moment(
												payment.term_details.start_date,
												'YYYY-MM-DD',
											).format('Do MMM YYYY')
										}}
										-
										{{
											moment(
												payment.term_details.end_date,
												'YYYY-MM-DD',
											).format('Do MMM YYYY')
										}})
									</div>
									<div class="class">
										{{
											invoice_details.school_details
												.school_name
										}}
									</div>
									<div class="class">
										Student:
										{{
											invoice_details.student_details
												.student_name
										}}
									</div>
									<div class="time">
										Release Date:
										<span
											class="date"
											v-if="
												payment.term_details.start_date
											"
											>{{
												moment(
													payment.term_details
														.start_date,
													'YYYY-MM-DD',
												).format('Do MMM YYYY')
											}}</span
										>
										<span class="date" v-else>-</span>
									</div>

									<!-- <div class="total">{{invoice_details.currency || 'KES'}} {{utils.numberWithCommas(invoice_details.total_amount)}}</div> -->
									<div class="total">
										{{
											utils.numberWithCommas2(
												invoice_details.total_amount,
											)
										}}
									</div>

									<div class="term">
										<div class="small-title">FEES</div>

										<div
											class="price-item"
											v-for="(
												item, j
											) in payment.term_fees"
											:key="j"
										>
											<div class="row">
												<div class="col-8 item-title">
													{{ item.fee_name }}
												</div>
												<!-- <div class="col-4 amount">{{item.currency || 'KES'}} {{utils.numberWithCommas(item.provided_amount)}}</div> -->
												<div class="col-4 amount">
													{{
														utils.numberWithCommas2(
															item.provided_amount,
														)
													}}
												</div>
											</div>
										</div>
									</div>

									<div class="sum-total clearfis">
										<!-- <div class="total final f-r" :class="{'tx-yellow': payment.status !== 'paid'}">
                                 {{invoice_details.currency}} {{utils.numberWithCommas(invoice_details.total_amount)}}
                              </div> -->
										<div
											class="total final f-r"
											:class="{
												'tx-yellow':
													payment.status !== 'paid',
											}"
										>
											{{ calculateTotal(payment) }}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</Modal>
	</div>
</template>

<script>
export default {
	components: {
		Modal: () => import('../templates/others/modal'),
		Dropdown: () => import('@/libs/clarks/components/dropdown/dropdown'),
		DropdownItem: () =>
			import('@/libs/clarks/components/dropdown/dropdown-item'),
		DropdownMenu: () =>
			import('@/libs/clarks/components/dropdown/dropdown-menu'),
	},
	computed: {
		...mapGetters([
			'loading',
			'payment_breakdown',
			'selected_invoice',
			'invoice_details',
			'showPaymentBreakdown',
		]),
	},
	data() {
		return {
			utils,
			moment,
		};
	},
	methods: {
		...mapActions(['clickAction']),
		calculateTotal(term) {
			let total = 0;
			for (let i = 0; i < term.term_fees.length; i++) {
				if (term.term_fees[i].provided_amount) {
					total += term.term_fees[i].provided_amount;
				}
			}

			// return `KES ${utils.numberWithCommas(total)}`
			return `${utils.numberWithCommas2(total)}`;
		},
	},
	mounted() {},
};
</script>

<style lang="less">
.view-payment-breakdown {
	.total.final {
		color: var(--ne-green) !important;

		&.tx-yellow {
			color: var(--ne-yellow) !important;
		}
	}
}
</style>
